<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
    <path d="M12.04 7.198v9.716m4.859-4.858H7.183M11.993 23A10.993 10.993 0 1 0 1 12.007 10.993 10.993 0 0 0 11.993 23Z" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
</template>
